import React, { useState } from 'react';
import axios from 'axios'
import {firestore} from '../firebase'

function UserData() {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    address: '',
    phonenumber: '',
    bio: '',
  });
  const [check, setCheck] = useState(false);

  const { firstname, lastname, email, address, phonenumber, bio } = formData

  const handlechange = (e) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  }

  const onSubmitChange = async(e) => {
    e.preventDefault()
    if(phonenumber !== null) {
      localStorage.removeItem("formData")
      localStorage.setItem("formData", JSON.stringify(formData))

      const userRef = firestore.collection('users').doc(`${firstname}-${lastname}`)

      userRef.get().then(async(user) => {
        if(user.exists) {
          setFormData({
            ...formData,
            firstname: '',
            lastname: '',
            email: '',
            address: '',
            phonenumber: '',
            bio: '',
          })
          alert("This user has been registered!")
        } else {
          try {
            
            let result = await axios.get('https://eti-portal-v1.herokuapp.com/pay', {params: {firstname, email, phonenumber}})
            await result.data
            const url = result.data.data
            const {link} = url.data
            window.location.replace(link)
          } catch (error) {
            console.error(error);
          }
        }
        
      }).catch((error) => {
        alert(error)
      })
    } else {
      alert('passwords do not match')
    }
  }

    return (
        <>
          <div className="d-lg-flex half mt-5">
          <div className="bg  order-1 order-md-2" style={{backgroundImage: "url('/assets/img001.jpeg')", filter: 'blur(1px)'}} >
          </div>
            <div className="contents order-2 order-md-1">

              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-md-7 py-5">
                    <h3>Register</h3>
                    <p className="mb-4">Lorem ipsum dolor sit amet elit. Sapiente sit aut eos consectetur adipisicing.</p>
                    <form onSubmit={onSubmitChange} >
                      <div className="row py-1">
                        <div className="col-md-6">
                          <div className="form-group first">
                            <label htmlFor="fname">First Name</label>
                            <input type="text" 
                            name="firstname" 
                            className="form-control" 
                            placeholder="e.g. John" 
                            id="fname" 
                            value={firstname}
                            onChange={handlechange}
                            required
                            />
                          </div>    
                        </div>
                        <div className="col-md-6">
                          <div className="form-group first">
                            <label htmlFor="lname">Last Name</label>
                            <input type="text" 
                            name="lastname" 
                            className="form-control" 
                            placeholder="e.g. Smith"
                            value={lastname}
                            onChange={handlechange}
                            required
                            />
                          </div>    
                        </div>
                      </div>
                      <div className="row py-1">
                        <div className="col-md-12">
                          <div className="form-group first">
                          <label htmlFor="email">Email Address</label>
                          <input type="email" 
                          name="email" 
                          className="form-control"
                          placeholder="e.g. john@your-domain.com"
                          value={email}
                          onChange={handlechange}
                          required
                          />
                        </div>    
                      </div>
                    </div>
                      
                    <div className="row py-1">
                      <div className="col-md-6">
                        <div className="form-group first">
                          <label htmlFor="phonenumber">Phone Number</label>
                          <input type="tel" 
                          name="phonenumber" 
                          className="form-control" 
                          placeholder="+00 0000 000 0000" 
                          value={phonenumber}
                          onChange={handlechange}
                          required
                          />
                        </div>    
                      </div>
                      <div className="col-md-6">
                        <div className="form-group first">
                          <label htmlFor="lname">Address</label>
                          <input type="text" 
                          name="address" 
                          className="form-control" 
                          placeholder="where do you reside" 
                          value={address}
                          onChange={handlechange}
                          />
                        </div>    
                      </div>
                    </div>

                    <div className="row py-1">
                        <div className="col-md-12">
                          <div className="form-group first">
                          <label htmlFor="email">About You</label>
                          <textarea minLength="100" type="text" 
                          name="bio" 
                          className="form-control"
                          placeholder="Tell us in abit what we need to know about you and which of our programs interests you"
                          value={bio}
                          onChange={handlechange}
                          required
                          />
                        </div>    
                      </div>
                    </div>
                    
                    <div className="d-flex mb-5 mt-4 align-items-center">
                      <div className="d-flex align-items-center">
                      <label className="control control--checkbox mb-0"><span className="caption">Creating an account means you're okay with our <a href="#terms">Terms and Conditions</a> and our <a href="#policy">Privacy Policy</a>.</span>
                        <input type="checkbox" name="checkbox" onChange={()=> setCheck(!check)} required/>
                        <div className="control__indicator"></div>
                      </label>
                    </div>
                  </div>

                <button type="submit" 
                className="btn px-5 btn-primary" 
                >Register</button>

              </form>
          </div>
        </div>
      </div>
    </div>

    
      </div>
      <hr/>
    </>
  );
}

export default UserData;